import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as Action_Util from '../actions/util'

import {NavBar,List,InputItem} from 'antd-mobile'
const objectAssign = require('object-assign');

class Main extends React.Component {
	constructor(props) {
		super(props);
        const {actions} = props;
        actions.setScrollHeight(0.9);
    }
	render() {
		const {router,scrollHeight} = this.props;
		const data = !!localStorage.me ? JSON.parse(localStorage.me).member : "";
	    return <div className='csm-body-wapper'>
		    <NavBar iconName="left" onLeftClick={()=>{router.push("/apps")}}>
		        { '用户信息' }
		    </NavBar>
		    <div className="csm-scroll-wapper"  style={{height:scrollHeight}}>
			    <List>
		      		<InputItem editable={false} value={ data ? data.m_name : "" } >用户名</InputItem>
		      		<InputItem editable={false} value={ data ? data.m_role : "" } >用户类型</InputItem>
		      		<InputItem editable={false} value={ data ? data.m_position : "" } >岗位</InputItem>
		      		<InputItem editable={false} value={ data ? data.m_Comname : "" } >公司</InputItem>
		      		<InputItem editable={false} value={ data ? data.m_branch : "" } >分部</InputItem>
		      		<InputItem editable={false} value={ data ? data.m_branch : "" } >部门</InputItem>
				</List>
			</div>
	    </div>
	}
}

const mapStateToProps = state => {
    const {app,util} = state;
    return {
    	scrollHeight: util.scrollHeight,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(objectAssign({},Action_Util), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);


// WEBPACK FOOTER //
// ./project/components/User.js